module.exports = __webpack_public_path__ + "img/material_blurb1.a1d0b1c5.png";